// removed by extract-text-webpack-plugin
module.exports = {"liveMeetingsMenuItem":"LiveMeetingsMenuItem-liveMeetingsMenuItem","active":"LiveMeetingsMenuItem-active","meetingsPip":"LiveMeetingsMenuItem-meetingsPip"};